<template>
  <div class="rankings has-panel">

    <div class="loading" v-if="!fightRankings && !formsRankings && selectedCategoryId"></div>

    <div class="categories-nav" :class="{hidden: fightRankings || formsRankings}">
      <div class="categories-nav-divisions">
        <div class="categories-nav-division" @click="selectedDivision = 'fight'" :class="{active: selectedDivision === 'fight'}">{{$t('message.fight')}}</div>
        <div class="categories-nav-division" @click="selectedDivision = 'forms'" :class="{active: selectedDivision === 'forms'}">{{$t('message.forms')}}</div>
      </div>
      <div class="categories-nav-filters">
        <div class="categories-nav-filters-clear" @click="clearFilters" v-if="showFilters">{{$t('message.clearFilters')}}</div>
        <div class="categories-nav-filters-show" @click="showFilters = !showFilters"></div>
        <div class="categories-nav-filters-columns" v-if="showFilters">
          <div class="categories-nav-filters-column">
            <div class="categories-nav-filter">
              <input type="checkbox" id="kids" value="kids" v-model="ageFilters">
              <label for="kids">Kids (-12)</label>
            </div>
            <div class="categories-nav-filter">
              <input type="checkbox" id="juniors" value="juniors" v-model="ageFilters">
              <label for="juniors">Juniors (13-14)</label>
            </div>
            <div class="categories-nav-filter">
              <input type="checkbox" id="teens" value="teens" v-model="ageFilters">
              <label for="teens">Teens (15-17)</label>
            </div>
            <div class="categories-nav-filter">
              <input type="checkbox" id="adults" value="adults" v-model="ageFilters">
              <label for="adults">Adults (18+)</label>
            </div>
            <div class="categories-nav-filter">
              <input type="checkbox" id="veterans" value="veterans (+35)" v-model="ageFilters">
              <label for="veterans">Veterans (35+)</label>
            </div>
            <div class="categories-nav-filter">
              <input type="checkbox" id="executives" value="executives (+45)" v-model="ageFilters">
              <label for="executives">Executives (45+)</label>
            </div>
            <div class="categories-nav-filter">
              <input type="checkbox" id="seniors" value="seniors (+55)" v-model="ageFilters">
              <label for="seniors">Seniors (55+)</label>
            </div>
          </div>

          <div class="categories-nav-filters-column" v-if="selectedDivision === 'fight'">
            <div class="categories-nav-filter">
              <input type="checkbox" id="pointfighting" value="pointfighting" v-model="fightFilters">
              <label for="pointfighting">Point Fighting</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="kumite" value="karate kumite" v-model="fightFilters">
              <label for="kumite">Karate Kumite</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="lightcontact" value="light contact" v-model="fightFilters">
              <label for="lightcontact">Light Contact</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="kicklight" value="kick light" v-model="fightFilters">
              <label for="kicklight">Kick Light</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="fullcontact" value="full contact" v-model="fightFilters">
              <label for="fullcontact">Full Contact</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="k1" value="k1" v-model="fightFilters">
              <label for="k1">K1</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="neopro" value="neopro" v-model="fightFilters">
              <label for="neopro">NeoPro Boxing</label>
            </div> 
            <!--iv class="categories-nav-filter">
              <input type="checkbox" id="thaiboxing" value="thai boxing" v-model="fightFilters">
              <label for="thaiboxing">Thai Boxing</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="mma" value="mma" v-model="fightFilters">
              <label for="mma">MMA</label>
            </div-->          
          </div>

          <div class="categories-nav-filters-column" v-if="selectedDivision === 'forms'">
            <div class="categories-nav-filter">
              <input type="checkbox" id="freestyle" value="freestyle" v-model="formsFilters">
              <label for="freestyle">Freestyle</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="hardstyle" value="hardstyle" v-model="formsFilters">
              <label for="hardstyle">Hardstyle</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="itf" value="itf" v-model="formsFilters">
              <label for="itf">ITF Style</label>
            </div>                 
            <div class="categories-nav-filter">
              <input type="checkbox" id="karatetraditional" value="karate traditional" v-model="formsFilters">
              <label for="karatetraditional">Karate Traditional</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="karateweapons" value="karate weapons" v-model="formsFilters">
              <label for="karateweapons">Karate Weapons</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="korean" value="korean" v-model="formsFilters">
              <label for="korean">Korean Style</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="softstyle" value="softstyle" v-model="formsFilters">
              <label for="softstyle">Softstyle</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="traditionalstyle" value="traditional style" v-model="formsFilters">
              <label for="traditionalstyle">Traditional Style</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="weapons" value="weapons without music" v-model="formsFilters">
              <label for="weapons">Weapons</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="weaponsmusic" value="weapons with music" v-model="formsFilters">
              <label for="weaponsmusic">Weapons with Music</label>
            </div>          
          </div>
          
        </div>
      </div>

      <div class="categories-nav-content" v-if="selectedDivision === 'fight'">
        <div class="categories-nav-item" v-for="item in filteredFightCategories" :key="item.id" @click="getFightRankings(item.id)">
          <div class="categories-nav-item-code">{{item.bez_short}}</div>
          <div class="categories-nav-item-title">{{item.cat_name}} {{item.bez}} {{item.gender}} {{item.vz}}{{item.val}}{{item.unity}}</div>
        </div>
      </div>
      <div class="categories-nav-content" v-if="selectedDivision === 'forms'">
        <div class="categories-nav-item" v-for="item in filteredFormsCategories" :key="item.id" @click="getFormsRankings(item.id)">
          <div class="categories-nav-item-code">{{item.bez_short}}</div>
          <div class="categories-nav-item-title">{{item.cat_name}} {{item.bez}} {{item.gender}}</div>
        </div>
      </div>
    </div>

    <div class="container">
      <h1 class="headline">GCO {{$t('message.rankings')}}</h1>
      <h2 class="center">{{$t('message.nationalTournaments')}} {{$t('country.germany')}}</h2>
      <h2 class="headline center has-back" v-if="fightRankings"><div class="headline-back-btn" @click="reset()"></div>{{fightRankings.category.cat_name}} {{fightRankings.category.gender}} {{fightRankings.category.bez}} {{fightRankings.category.vz}}{{fightRankings.category.val}}{{fightRankings.category.unity}}<br>{{fightRankings.season.title}}</h2>
      <h2 class="headline center has-back" v-if="formsRankings"><div class="headline-back-btn" @click="reset()"></div>{{formsRankings.category.cat_name}} {{formsRankings.category.gender}} {{formsRankings.category.bez}}</h2>

      <div class="ranking-table-outer" v-if="fightRankings || formsRankings">
        <div class="ranking-tournaments hide-mobile" v-if="events">
          <div class="ranking-tournament" v-for="(item, index) in events" :key="index">    
            <div class="ranking-tournament-inner" v-if="index > 0">{{item.title}}</div>
            <div class="ranking-tournament-inner" v-if="index === 0">{{$t('message.seasonStart')}}</div>
          </div>     
          <div class="ranking-tournament">    
            <div class="ranking-tournament-inner">{{$t('message.total')}}</div>
          </div>     
        </div>

        <div class="ranking-list-outer" v-if="fightRankings">
          <p v-if="fightRankings.category.ranking.length === 0">{{$t('message.noRankingsFound')}}</p>
          <div class="list-item" v-for="(item, index) in fightRankings.category.ranking" :key="item.map" @click="goMember(item)" :class="{inactive: item.organisation_id !== '1' && item.organisation_id !== '5'}">
            <div class="list-item-index">{{index + 1}}</div>
            <div class="list-item-image"><img :src="item.memberImage" @error="onImageError"/></div>
            <div class="list-item-caption">
              <div class="list-item-title">{{item.firstname}} {{item.lastname}}</div>
              <div class="list-item-subtitle">MAP {{item.map}}</div>
            </div>
            <div class="list-item-additionals">
              <div class="list-item-additional ranking-event-points hide-mobile" v-for="event in events" :key="event.id">{{item.events.find(o => o.bez_short == event.bez_short) ? item.events.find(o => o.bez_short == event.bez_short).points : "-"}}</div>       
              <div class="list-item-additional ranking-total-score">{{item.sumPoints}}</div>       
              <div class="list-item-additional hide-mobile"><img :src="logoPath + item.dojo_id + '.jpg'" @error="onLogoImageError"/></div>            
            </div>
          </div>
        </div>

        <div class="ranking-list-outer" v-if="formsRankings">
          <p v-if="formsRankings.category.ranking.length === 0">{{$t('message.noRankingsFound')}}</p>
          <div class="list-item" v-for="(item, index) in formsRankings.category.ranking" :key="item.map" @click="goMember(item)" :class="{inactive: item.organisation_id !== '1' && item.organisation_id !== '5'}">
            <div class="list-item-index">{{index + 1}}</div>
            <div class="list-item-image"><img :src="item.memberImage" @error="onImageError"/></div>
            <div class="list-item-caption">
              <div class="list-item-title">{{item.firstname}} {{item.lastname}}</div>
              <div class="list-item-subtitle">MAP {{item.map}}</div>
            </div>
            <div class="list-item-additionals">
              <div class="list-item-additional ranking-event-points hide-mobile" v-for="event in events" :key="event.id">{{item.events.find(o => o.bez_short == event.bez_short) ? item.events.find(o => o.bez_short == event.bez_short).points : "-"}}</div>       
              <div class="list-item-additional ranking-total-score">{{item.sumPoints}}</div>       
              <div class="list-item-additional hide-mobile"><img :src="logoPath + item.dojo_id + '.jpg'" @error="onLogoImageError"/></div>            
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'belts',
  data () {
    return {
      selectedDivision: 'fight',
      selectedCategoryId: null,
      showFilters: true,
      ageFilters: ['kids', 'juniors', 'teens', 'adults', 'veterans (+35)', 'executives (+45)', 'seniors (+55)'],
      fightFilters: ['pointfighting', 'karate kumite', 'light contact', 'kick light', 'full contact', 'k1', 'neopro'],
      formsFilters: ['freestyle', 'hardstyle', 'itf', 'karate traditional', 'karate weapons', 'korean', 'softstyle', 'traditional style', 'weapons without music', 'weapons with music']
    }
  },
  methods: {
    getFightCategories: function () {
      this.$store.dispatch('rankings/getFightCategories').then(() => {
        this.getFormsCategories()
      })
    },
    getFormsCategories: function () {
      this.$store.dispatch('rankings/getFormsCategories')
    },
    getFightRankings: function (id) {
      this.selectedCategoryId = id
      this.$store.commit('rankings/SET_FIGHT_RANKINGS', null)
      this.$store.commit('rankings/SET_FORMS_RANKINGS', null)
      this.$store.dispatch('rankings/getFightRankings', id)
    },
    getFormsRankings: function (id) {
      this.selectedCategoryId = id
      this.$store.commit('rankings/SET_FIGHT_RANKINGS', null)
      this.$store.commit('rankings/SET_FORMS_RANKINGS', null)
      this.$store.dispatch('rankings/getFormsRankings', id)
    },
    clearFilters: function () {
      this.ageFilters = []
      this.fightFilters = []
      this.formsFilters = []
    },
    reset: function () {
      this.$store.commit('rankings/SET_FIGHT_RANKINGS', null)
      this.$store.commit('rankings/SET_FORMS_RANKINGS', null)
    },
    goBelt: function (id, name) {
      // window.location.href = './#/belts/' + id + '/members'
      var breadcrumb = {
        name: name,
        route: '/belts/' + id + '/members'
      }
      this.$store.commit('ADD_BREADCRUMB', breadcrumb)
      this.$router.push({path: breadcrumb.route})
    },
    goMember: function (item) {
      var breadcrumb = {
        name: item.firstname + ' ' + item.lastname,
        route: '/member/' + item.map
      }
      this.$store.commit('ADD_BREADCRUMB', breadcrumb)
      this.$router.push(breadcrumb.route)
    },
    onLogoImageError: function (event) {
      event.target.src = './dojo-dummy.png'
    },
    onImageError: function (event) {
      event.target.src = './person-dummy.png'
    }
  },
  computed: {
    filteredFightCategories: function () {
      if (this.fightCategories) {
        return this.fightCategories.filter(category => 
          this.ageFilters.some(x => category.bez.toLowerCase().includes(x)) && this.fightFilters.some(x => category.cat_name.toLowerCase().includes(x)) && !category.cat_name.toLowerCase().includes('team')
        )
      } else {
        return null
      }      
    },
    filteredFormsCategories: function () {
      if (this.formsCategories) {      
        return this.formsCategories.filter(category => 
          this.ageFilters.some(x => category.bez.toLowerCase().includes(x)) && this.formsFilters.some(x => category.cat_name.toLowerCase().includes(x)) && !category.cat_name.toLowerCase().includes('team')
        )
      } else {
        return null
      }
    },
    events: function () {
      var activeEvents = []
      if (this.fightRankings) {    
        if (this.fightRankings.category.ranking.length === 0) return null
        activeEvents = [...this.fightRankings.events]
        return activeEvents.splice(0, this.fightRankings.category.ranking[0].events.length)
      }
      if (this.formsRankings) {
        if (this.formsRankings.category.ranking.length === 0) return null
        activeEvents = [...this.formsRankings.events]
        return activeEvents.splice(0, this.formsRankings.category.ranking[0].events.length)
      }
      return null
    },
    ...mapGetters({
      fightCategories: 'rankings/fightCategories',
      formsCategories: 'rankings/formsCategories',
      fightRankings: 'rankings/fightRankings',
      formsRankings: 'rankings/formsRankings',
      logoPath: 'dojos/logoPath'
    })
  },
  created: function () {
    this.getFightCategories()
  }
}
</script>
